export const urlPatterns = {
  url: /(?:(http|https|).\/\/)|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9].*/gi,
  twitter: /(?:(http|https|)(?:(twitter))\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]+\/[a-z0-9.]*(?:\/|)/gi,
  facebook: /(?:(http|https|)(?:(facebook|instagram))\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]+\/[a-z0-9.]*(?:\/|)/gi,
  linkedin: /(?:(http|https|)(?:(linkedin))\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]+\/+in\/[a-z0-9.]*(?:\/|)/gi,
  urlRequiredHttp: /((http|https|).\/\/)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9].*/gi
};
